import { DateRangeDialogEvent } from "../../../../../../js/lib/components/DateRangeDialog";
import { TLCEventManager } from "../../../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../../../js/main/constants";
import { ApplicationData } from "../../../ApplicationData";
import { LoanHistoryClientManager } from "../../../ClientManagers/LoanHistoryClientManager";
import { LS2PAC_Utils } from "../../../utils/Utils";
import { MyAccountBaseSubView } from "../BaseSubView";

export class LoanHistoryView extends MyAccountBaseSubView {
  constructor(options) {
    options = options || {};
    options.template = "tmpl/myAccount/accountActivity/loanHistory.html";
    options.itemsTemplate =
      "tmpl/myAccount/accountActivity/loanHistoryItems.html";
    options.viewName = LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.loanHistory;
    options.id = options.viewName;
    options.dataFieldName = "loanHistory";
    options.tabText = ApplicationData.language.loanHistory;
    options.addBookJackets = true;
    options.bookJacektIdSuffix = "_loansHistory_bookJacket";
    options.ratingsSuffix = "loanHistory_ratingsControl_";

    options.sortOptions = [
      {
        sortValue: "OutDate",
        sortText:
          ApplicationData.language.sortBy +
          " " +
          ApplicationData.language.checkoutDate,
      },
      {
        sortValue: "Title",
        sortText:
          ApplicationData.language.sortBy +
          " " +
          ApplicationData.language.title,
      },
      {
        sortValue: "Author",
        sortText:
          ApplicationData.language.sortBy +
          " " +
          ApplicationData.language.author,
      },
    ];

    super(options);
  }
  getClientManager(){
    return LoanHistoryClientManager.getInstance({
      resultsPanelId: this.id,
    });
  }
  fetchData() {
    var _this = this;
    this.clientManager.getTotalCount(function (count) {
      _this.clientManager.setTotalHits(count);
      $("#" + LS2PAC_CONSTANTS.Ids.MyAccountPage.totalLoans).text(count);
      TLCEventManager.fireEvent(_this.clientManager.searchEvent);
    });
  }
  addEvents() {
    var _this = this;
    this.addEventHandler($("#" + this.id), "click", ".printLoanHistory", () => {
      TLCEventManager.fireEvent(DateRangeDialogEvent, {});
      return false;
    });
  }
  manipulateData() {
    var data = this.pageData[this.dataFieldName];
    $.each(data, function (index, loan) {
      loan.outDateString = LS2PAC_Utils.getDateString(loan.outDate);
    });
  }
  addListeners() {
    var _this = this;
  }
}
